import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import SocialOnMarketplaceFeature from "./SocialOnMarketplaceFeature";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import SocialOnMarketplaceBenefit from "./SocialOnMarketplaceBenefit";
import "./SocialOnMarketplace.css";
// Main component for SocialOnMarketplace
export default function SocialOnMarketplace() {
  // Overview data
  const data1 = [
    "Contract Farming: Facilitates contract farming of assets and raw products, optimizing agricultural production and distribution.",
    "Contract Manufacturing: Enables contract manufacturing of processed products, streamlining production and distribution for businesses.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="social-onmarketplace-bg"
        bannerTitle={["Social Marketplace"]}
        bannerbodycopy="Social CMonMarketplace | Social CFonMarketplace"
      />

      {/*  Overview  Section*/}
      <SolutionEcosystem title="Overview" type="SM" />

      {/*  Overview Feature */}
      <Container>
        <OverviewFeatures data1={data1} />
      </Container>

      {/*  Features & Benefits Section */}
      <SocialOnMarketplaceFeature />
      <SocialOnMarketplaceBenefit />
    </>
  );
}

